import { render, staticRenderFns } from "./deductions.vue?vue&type=template&id=4c36bf96&"
import script from "./deductions.vue?vue&type=script&lang=js&"
export * from "./deductions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports